module.exports = __webpack_public_path__ + "./imgs/biz_content_03_bg.png?d80ae75907af52625a259209cdd53c94";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/biz_content_03_bg.png
// module id = 10
// module chunks = 0 1 2 3 4 5 6